// extracted by mini-css-extract-plugin
export var topcomponent = "manifesto-module--topcomponent--3SRVp";
export var manifestoDescription = "manifesto-module--manifestoDescription--2FyMI";
export var manifesto = "manifesto-module--manifesto--3xIZR";
export var priciple = "manifesto-module--priciple--1bhMl";
export var description = "manifesto-module--description--2BqR2";